import { ElementType, ReactNode } from "react";

import sanitizeHtml from "sanitize-html";

export type SanitizedHtmlProps = {
    // @ts-expect-error - TS2304: Cannot find name 'InnerHTML'
    readonly innerHTML: string | InnerHTML | ReactNode[];
    readonly tagName?: ElementType;
};

export const SanitizedHtml = /* istanbul ignore next */ ({
    innerHTML,
    tagName: Component = "span"
}: SanitizedHtmlProps) => {
    const html =
        Array.isArray(innerHTML) && innerHTML.length === 1
            ? innerHTML[0]
            : innerHTML;
    if (typeof html === "string") {
        return (
            <Component
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
            />
        );
    } else {
        return null;
    }
};
